<template>
  <div class="section">
    <div class="container">
      <!-- Page Header -->
      <div class="mb-md">
        <div class="columns is-vcentered">
          <div class="column is-one-third">
            <breadcrumbs :history="[{ label: 'Settings', name: 'settings'}]" current="Missed Questions" />
          </div>
          <div class="column is-one-third">
            <h1 class="has-text-centered is-size-4">Missed Questions</h1>
          </div>
        </div>
      </div>
      <div class="pb-lg mb-lg">
        <MissedQuestions />
      </div>
    </div>
  </div>
</template>

<script>
import MissedQuestions from '../components/Assistant/MissedQuestions'
export default {
  components: {
    MissedQuestions
  }
}
</script>
